import React from 'react'

import Box from 'components_new/atoms/Box'
import Button from 'components_new/atoms/Button'
import Icon from 'components_new/atoms/Icon'
import Text from 'components_new/atoms/Text'

import MarkdownContent from 'components_new/molecules/MarkdownContent'

import { dataHealthTabPath } from 'components_new/templates/internal/DataHealth/lib'

import { INCIDENT_PROCESS_MARKDOWN } from './content'

/** The incident process as a single readable column under Datahälsa. */
const DataHealthIncidentProcessTemplate = () => (
  <Box sx={{ height: '100%', overflowY: 'auto', p: '24px 24px 96px' }}>
    <Box sx={{ maxWidth: 760, mx: 'auto' }}>
      <Button
        startIcon={<Icon fontSize="small" name="ArrowBackOutlined" />}
        sx={{ ml: -1 }}
        to={dataHealthTabPath('overview')}
        variant="text"
      >
        Till Datahälsa
      </Button>

      <Text
        component="h1"
        sx={{
          fontWeight: 700,
          letterSpacing: '-0.05em',
          lineHeight: 1.1,
          mt: 2
        }}
        variant="h3"
      >
        Incidentprocess
      </Text>
      <Text sx={{ color: 'text.secondary', mb: 4, mt: 1 }} variant="body1">
        Fel som kräver omkörning av kunddata
      </Text>

      <Box
        component="article"
        sx={{
          '& code': {
            bgcolor: 'action.hover',
            borderRadius: 0.5,
            fontFamily: 'ui-monospace, Menlo, monospace',
            fontSize: '0.875em',
            px: 0.5
          }
        }}
      >
        <MarkdownContent>{INCIDENT_PROCESS_MARKDOWN}</MarkdownContent>
      </Box>
    </Box>
  </Box>
)

DataHealthIncidentProcessTemplate.displayName =
  'DataHealthIncidentProcessTemplate'
export default DataHealthIncidentProcessTemplate
